import { JsonObject, JsonProperty } from "json2typescript";
import { DateConverter } from "domain/entities/decorators/DateConverter";
import { DrugResult } from "domain/entities//drug/structures/DrugResult";
import { SeverityResult } from "domain/entities/severity";

@JsonObject("DrugTripletInteractionResult")
export class DrugTripletInteractionResult {
    @JsonProperty("dit_id", Number)
    id: number = 0;
    @JsonProperty("dru_id1", Number)
    drugId1: number = 0;
    @JsonProperty("Drug1", DrugResult)
    drug1?: DrugResult;
    @JsonProperty("dru_id2", Number)
    drugId2: number = 0;
    @JsonProperty("Drug2", DrugResult)
    drug2?: DrugResult;
    @JsonProperty("dru_id3", Number)
    drugId3?: Number = 0;
    @JsonProperty("Drug3", DrugResult)
    drug3?: DrugResult;
    @JsonProperty("dse_id12", Number)
    severityId12: number | null = null;;
    @JsonProperty("DDISeverity12", SeverityResult)
    severity12?: SeverityResult;
    @JsonProperty("dse_id13", Number )
    severityId13: number | null = null;;
    @JsonProperty("DDISeverity13", SeverityResult)
    severity13?: SeverityResult;
    @JsonProperty("dse_id23", Number)
    severityId23: number | null = null;;
    @JsonProperty("DDISeverity23", SeverityResult)
    severity23?: SeverityResult;
    @JsonProperty("dit_relation12", String)
    relation12: string = "";
    @JsonProperty("dit_relation13", String)
    relation13: string = "";
    @JsonProperty("dit_relation23", String)
    relation23: string = "";
    @JsonProperty("din_effect12", String)
    effect12: string = "";
    @JsonProperty("din_effect13", String)
    effect13: string = "";
    @JsonProperty("din_effect23", String)
    effect23: string = "";
    @JsonProperty("din_description12", String)
    description12: string = "";
    @JsonProperty("din_description13", String)
    description13: string = "";
    @JsonProperty("din_description23", String)
    description23: string = "";
    @JsonProperty("din_evidence12", String)
    evidence12: string = "";
    @JsonProperty("din_evidence13", String)
    evidence13: string = "";
    @JsonProperty("din_evidence23", String)
    evidence23: string = "";
    @JsonProperty("din_evidence_source12", String)
    evidenceSource12: string = "";
    @JsonProperty("din_evidence_source13", String)
    evidenceSource13: string = "";
    @JsonProperty("din_evidence_source23", String)
    evidenceSource23: string = "";
    @JsonProperty("din_source12", String)
    sources12: string = "";
    @JsonProperty("din_source13", String)
    sources13: string = "";
    @JsonProperty("din_source23", String)
    sources23: string = "";
    @JsonProperty("dti_id12", Number)
    typeId12: number = 0;
    @JsonProperty("dti_id21", Number)
    typeId21: number = 0;
    @JsonProperty("dti_id13", Number)
    typeId13: number = 0;
    @JsonProperty("dti_id31", Number)
    typeId31: number = 0;
    @JsonProperty("dti_id23", Number)
    typeId23: number = 0;
    @JsonProperty("dti_id32", Number)
    typeId32: number = 0;
    @JsonProperty("dit_created_at", DateConverter)
    createdAt: Date = new Date();
    @JsonProperty("dit_updated_at", DateConverter)
    updatedAt: Date = new Date();
}